import { borderConfigToStyle } from '../border-config/border-config.mapper';
import { Border } from './border.model';

export const borderToStyle = (border?: Border) => {
    if (!border) {
        return undefined;
    }

    if ('color' in border) {
        const style = borderConfigToStyle(border);

        return {
            borderLeft: style,
            borderRight: style,
            borderTop: style,
            borderBottom: style,
        };
    } else {
        return {
            borderLeft: border.left
                ? borderConfigToStyle(border.left)
                : undefined,
            borderRight: border.right
                ? borderConfigToStyle(border.right)
                : undefined,
            borderTop: border.top ? borderConfigToStyle(border.top) : undefined,
            borderBottom: border.bottom
                ? borderConfigToStyle(border.bottom)
                : undefined,
        };
    }
};
